{
    "coordinates": [
        31.932758634829796,
        35.23915226561854
    ],
    "tooltip": "Ein Yabrud",
    "title": "Ein Yabrud Quarry",
    "country": "Palestine",
    "period": "Cretaceous"
}
